import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/der-perfekte-schlusssatz-fuer-deine.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')